module.exports = __webpack_public_path__ + "img/ZB_home_page.0bad0b0a.webp";